import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'emissionsReport',
  initialState: { items: [] },
  reducers: {
    setItems(state, action) { state.items = action.payload; },
  }
});

export { actions as emissionsReportActions };
export { reducer as emissionsReportReducer };
